export default __webpack_public_path__ + "static/media/vector-cover-image.924e1bd5.png";